import React, { useState, useEffect } from 'react';
import styled, { keyframes, css } from 'styled-components';

const INTERVAL_MS = 12000;
const FADE_MS = 2000;
const BASE_URL = 'https://belvoircastlepull.b-cdn.net/Caroline%20Screen/Slide';

const KEPT_SLIDES = [1, 2, 3, 5, 6, 7, 12, 18, 22, 24, 27, 31, 33];

const SLIDE_URLS = [
  ...KEPT_SLIDES.map(n => `${BASE_URL}${n}.jpg`),
  'https://BelvoirCastlePull.b-cdn.net/Caroline%20Screen/v2/AN4T0021%20(1)%20(1).jpg',
  'https://BelvoirCastlePull.b-cdn.net/Caroline%20Screen/v2/AN4T9230%20(2)%20(1).jpg',
  'https://BelvoirCastlePull.b-cdn.net/Caroline%20Screen/v2/Castle%20-%20Hero.png',
  'https://BelvoirCastlePull.b-cdn.net/Caroline%20Screen/v2/CJP%20Belvoir%20Castle-124%20(2).jpg',
  'https://BelvoirCastlePull.b-cdn.net/Caroline%20Screen/v2/CJP%20Belvoir%20Castle-152%20(2).jpg',
  'https://BelvoirCastlePull.b-cdn.net/Caroline%20Screen/v2/CJP%20Belvoir%20Castle-18%20(2).jpg',
  'https://BelvoirCastlePull.b-cdn.net/Caroline%20Screen/v2/CJP%20Belvoir%20Castle-195%20(1)%20(2).jpg',
  'https://BelvoirCastlePull.b-cdn.net/Caroline%20Screen/v2/CJP%20Belvoir%20Castle-227%20(1).jpg',
  'https://BelvoirCastlePull.b-cdn.net/Caroline%20Screen/v2/CSPSHOOT210906_0087%20(1)%20(1).jpg',
  'https://BelvoirCastlePull.b-cdn.net/Caroline%20Screen/v2/D16%20(2).jpg',
  'https://BelvoirCastlePull.b-cdn.net/Caroline%20Screen/v2/IMG_5340%20(2).jpg',
  'https://BelvoirCastlePull.b-cdn.net/Caroline%20Screen/v2/JonathanMMcGee_BelvoirDinner_039%20(1).jpg',
];

const fadeInAnim = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const fadeOutAnim = keyframes`
  from { opacity: 1; }
  to   { opacity: 0; }
`;

const Wrapper = styled.div`
  position: fixed;
  inset: 0;
  background: #000;
  overflow: hidden;
`;

const Slide = styled.div`
  position: absolute;
  inset: 0;
  background-image: url(${({ $src }) => $src});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  ${({ $state }) =>
    $state === 'in' &&
    css`
      animation: ${fadeInAnim} ${FADE_MS}ms ease-in-out forwards;
    `}
  ${({ $state }) =>
    $state === 'out' &&
    css`
      animation: ${fadeOutAnim} ${FADE_MS}ms ease-in-out forwards;
    `}
`;

const CarolineScreen = () => {
  const [slides, setSlides] = useState([{ id: 1, index: 0, state: 'in' }]);

  useEffect(() => {
    let id = 1;
    const timer = setInterval(() => {
      id += 1;
      const nextIndex = (id - 1) % SLIDE_URLS.length;

      setSlides(prev => {
        const updated = prev.map(s => ({ ...s, state: 'out' }));
        return [...updated, { id, index: nextIndex, state: 'in' }];
      });

      // Remove the outgoing slide after the fade completes
      setTimeout(() => {
        setSlides(prev => prev.filter(s => s.state !== 'out'));
      }, FADE_MS + 50);
    }, INTERVAL_MS);

    return () => clearInterval(timer);
  }, []);

  return (
    <Wrapper>
      {slides.map(slide => (
        <Slide
          key={slide.id}
          $src={SLIDE_URLS[slide.index]}
          $state={slide.state}
        />
      ))}
    </Wrapper>
  );
};

export default CarolineScreen;
